/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface ClassSignupOverrides
 */
export interface ClassSignupOverridesOptional {
  /**
   *
   * @type {boolean}
   * @memberof ClassSignupOverrides
   */
  overrideAll?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassSignupOverrides
   */
  overrideCanEnroll?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassSignupOverrides
   */
  overrideClassStarted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassSignupOverrides
   */
  overrideClassCancelled?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassSignupOverrides
   */
  overrideStaggeredStart?: boolean;
  /**
   *
   * @type {string}
   * @memberof ClassSignupOverrides
   */
  typeOverride?: string;
}

export interface ClassSignupOverrides extends ClassSignupOverridesOptional {
  /**
   *
   * @type {boolean}
   * @memberof ClassSignupOverrides
   */
  overrideAll?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassSignupOverrides
   */
  overrideCanEnroll?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassSignupOverrides
   */
  overrideClassStarted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassSignupOverrides
   */
  overrideClassCancelled?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassSignupOverrides
   */
  overrideStaggeredStart?: boolean;
  /**
   *
   * @type {string}
   * @memberof ClassSignupOverrides
   */
  typeOverride?: string;
}

export interface ClassSignupOverridesTrackedI {
  /**
   *
   * @type {boolean}
   * @memberof ClassSignupOverrides
   */
  overrideAll?: boolean;
  overrideAllIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassSignupOverrides
   */
  overrideCanEnroll?: boolean;
  overrideCanEnrollIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassSignupOverrides
   */
  overrideClassStarted?: boolean;
  overrideClassStartedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassSignupOverrides
   */
  overrideClassCancelled?: boolean;
  overrideClassCancelledIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassSignupOverrides
   */
  overrideStaggeredStart?: boolean;
  overrideStaggeredStartIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ClassSignupOverrides
   */
  typeOverride?: string;
  typeOverrideIsSet: boolean;
}

transformDatesMap.set(
  "ClassSignupOverrides",
  function (model: ClassSignupOverrides) {},
);

export type ClassSignupOverridesMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  overrideAll: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  overrideCanEnroll: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  overrideClassStarted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  overrideClassCancelled: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  overrideStaggeredStart: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  typeOverride: PropertyMeta<MetaTypeBase<string>>;
}>;

export var ClassSignupOverridesMeta: ClassSignupOverridesMetaI =
  {} as ClassSignupOverridesMetaI;
ClassSignupOverridesMeta = typeMeta("ClassSignupOverrides", {
  overrideAll: propertyMeta(
    "overrideAll",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  overrideCanEnroll: propertyMeta(
    "overrideCanEnroll",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  overrideClassStarted: propertyMeta(
    "overrideClassStarted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  overrideClassCancelled: propertyMeta(
    "overrideClassCancelled",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  overrideStaggeredStart: propertyMeta(
    "overrideStaggeredStart",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  typeOverride: propertyMeta(
    "typeOverride",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
});

const metaI = ClassSignupOverridesMeta;

registerMeta(() => {});

export class ClassSignupOverridesTracked implements ClassSignupOverridesTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  overrideAll__I?: boolean = undefined;
  overrideAllIsSet: boolean = false;
  set overrideAll(v: undefined | boolean) {
    if (v !== undefined) {
      this.overrideAll__I = v;
      this.overrideAllIsSet = true;
    } else {
      this.overrideAll__I = v || undefined;
      this.overrideAllIsSet = false;
    }
    this.changeTracker = true;
  }
  get overrideAll() {
    return this.overrideAll__I;
  }
  overrideCanEnroll__I?: boolean = undefined;
  overrideCanEnrollIsSet: boolean = false;
  set overrideCanEnroll(v: undefined | boolean) {
    if (v !== undefined) {
      this.overrideCanEnroll__I = v;
      this.overrideCanEnrollIsSet = true;
    } else {
      this.overrideCanEnroll__I = v || undefined;
      this.overrideCanEnrollIsSet = false;
    }
    this.changeTracker = true;
  }
  get overrideCanEnroll() {
    return this.overrideCanEnroll__I;
  }
  overrideClassStarted__I?: boolean = undefined;
  overrideClassStartedIsSet: boolean = false;
  set overrideClassStarted(v: undefined | boolean) {
    if (v !== undefined) {
      this.overrideClassStarted__I = v;
      this.overrideClassStartedIsSet = true;
    } else {
      this.overrideClassStarted__I = v || undefined;
      this.overrideClassStartedIsSet = false;
    }
    this.changeTracker = true;
  }
  get overrideClassStarted() {
    return this.overrideClassStarted__I;
  }
  overrideClassCancelled__I?: boolean = undefined;
  overrideClassCancelledIsSet: boolean = false;
  set overrideClassCancelled(v: undefined | boolean) {
    if (v !== undefined) {
      this.overrideClassCancelled__I = v;
      this.overrideClassCancelledIsSet = true;
    } else {
      this.overrideClassCancelled__I = v || undefined;
      this.overrideClassCancelledIsSet = false;
    }
    this.changeTracker = true;
  }
  get overrideClassCancelled() {
    return this.overrideClassCancelled__I;
  }
  overrideStaggeredStart__I?: boolean = undefined;
  overrideStaggeredStartIsSet: boolean = false;
  set overrideStaggeredStart(v: undefined | boolean) {
    if (v !== undefined) {
      this.overrideStaggeredStart__I = v;
      this.overrideStaggeredStartIsSet = true;
    } else {
      this.overrideStaggeredStart__I = v || undefined;
      this.overrideStaggeredStartIsSet = false;
    }
    this.changeTracker = true;
  }
  get overrideStaggeredStart() {
    return this.overrideStaggeredStart__I;
  }
  typeOverride__I?: string = undefined;
  typeOverrideIsSet: boolean = false;
  set typeOverride(v: undefined | string) {
    if (v !== undefined) {
      this.typeOverride__I = v;
      this.typeOverrideIsSet = true;
    } else {
      this.typeOverride__I = v || undefined;
      this.typeOverrideIsSet = false;
    }
    this.changeTracker = true;
  }
  get typeOverride() {
    return this.typeOverride__I;
  }
  constructor(config?: ClassSignupOverridesOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: ClassSignupOverridesOptional,
    options?: AssignOptions,
  ): ClassSignupOverridesTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.overrideAll &&
      this.overrideAllApplyFilter(optionsRequired.filter)
    ) {
      this.overrideAll = config.overrideAll;
      if (optionsRequired.unassign) this.overrideAllIsSet = false;
      else this.overrideAllIsSet = true;
    }
    if (
      config.overrideCanEnroll &&
      this.overrideCanEnrollApplyFilter(optionsRequired.filter)
    ) {
      this.overrideCanEnroll = config.overrideCanEnroll;
      if (optionsRequired.unassign) this.overrideCanEnrollIsSet = false;
      else this.overrideCanEnrollIsSet = true;
    }
    if (
      config.overrideClassStarted &&
      this.overrideClassStartedApplyFilter(optionsRequired.filter)
    ) {
      this.overrideClassStarted = config.overrideClassStarted;
      if (optionsRequired.unassign) this.overrideClassStartedIsSet = false;
      else this.overrideClassStartedIsSet = true;
    }
    if (
      config.overrideClassCancelled &&
      this.overrideClassCancelledApplyFilter(optionsRequired.filter)
    ) {
      this.overrideClassCancelled = config.overrideClassCancelled;
      if (optionsRequired.unassign) this.overrideClassCancelledIsSet = false;
      else this.overrideClassCancelledIsSet = true;
    }
    if (
      config.overrideStaggeredStart &&
      this.overrideStaggeredStartApplyFilter(optionsRequired.filter)
    ) {
      this.overrideStaggeredStart = config.overrideStaggeredStart;
      if (optionsRequired.unassign) this.overrideStaggeredStartIsSet = false;
      else this.overrideStaggeredStartIsSet = true;
    }
    if (
      config.typeOverride &&
      this.typeOverrideApplyFilter(optionsRequired.filter)
    ) {
      this.typeOverride = config.typeOverride;
      if (optionsRequired.unassign) this.typeOverrideIsSet = false;
      else this.typeOverrideIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): ClassSignupOverridesTrackedI {
    const cloned = {} as ClassSignupOverridesTrackedI;
    if (
      this.overrideAllIsSetDeep() &&
      this.overrideAllApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.overrideAllIsSet = true;
      cloned.overrideAll = this.overrideAll;
    } else {
      //cloned.overrideAllIsSet = false
    }
    if (
      this.overrideCanEnrollIsSetDeep() &&
      this.overrideCanEnrollApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.overrideCanEnrollIsSet = true;
      cloned.overrideCanEnroll = this.overrideCanEnroll;
    } else {
      //cloned.overrideCanEnrollIsSet = false
    }
    if (
      this.overrideClassStartedIsSetDeep() &&
      this.overrideClassStartedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.overrideClassStartedIsSet = true;
      cloned.overrideClassStarted = this.overrideClassStarted;
    } else {
      //cloned.overrideClassStartedIsSet = false
    }
    if (
      this.overrideClassCancelledIsSetDeep() &&
      this.overrideClassCancelledApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.overrideClassCancelledIsSet = true;
      cloned.overrideClassCancelled = this.overrideClassCancelled;
    } else {
      //cloned.overrideClassCancelledIsSet = false
    }
    if (
      this.overrideStaggeredStartIsSetDeep() &&
      this.overrideStaggeredStartApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.overrideStaggeredStartIsSet = true;
      cloned.overrideStaggeredStart = this.overrideStaggeredStart;
    } else {
      //cloned.overrideStaggeredStartIsSet = false
    }
    if (
      this.typeOverrideIsSetDeep() &&
      this.typeOverrideApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.typeOverrideIsSet = true;
      cloned.typeOverride = this.typeOverride;
    } else {
      //cloned.typeOverrideIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): ClassSignupOverridesTrackedI {
    if (!this.overrideAllApplyFilter(filter)) this.overrideAllIsSet = false;

    if (!this.overrideCanEnrollApplyFilter(filter))
      this.overrideCanEnrollIsSet = false;

    if (!this.overrideClassStartedApplyFilter(filter))
      this.overrideClassStartedIsSet = false;

    if (!this.overrideClassCancelledApplyFilter(filter))
      this.overrideClassCancelledIsSet = false;

    if (!this.overrideStaggeredStartApplyFilter(filter))
      this.overrideStaggeredStartIsSet = false;

    if (!this.typeOverrideApplyFilter(filter)) this.typeOverrideIsSet = false;

    return this;
  }
  overrideAllApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassSignupOverridesMeta.overrideAll,
      ClassSignupOverridesMeta,
      this.overrideAll,
      this,
    );
  }
  overrideAllIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.overrideAllIsSet && this.overrideAllApplyFilter(filter))
      return true;

    return false;
  }
  overrideCanEnrollApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassSignupOverridesMeta.overrideCanEnroll,
      ClassSignupOverridesMeta,
      this.overrideCanEnroll,
      this,
    );
  }
  overrideCanEnrollIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.overrideCanEnrollIsSet &&
      this.overrideCanEnrollApplyFilter(filter)
    )
      return true;

    return false;
  }
  overrideClassStartedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassSignupOverridesMeta.overrideClassStarted,
      ClassSignupOverridesMeta,
      this.overrideClassStarted,
      this,
    );
  }
  overrideClassStartedIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.overrideClassStartedIsSet &&
      this.overrideClassStartedApplyFilter(filter)
    )
      return true;

    return false;
  }
  overrideClassCancelledApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassSignupOverridesMeta.overrideClassCancelled,
      ClassSignupOverridesMeta,
      this.overrideClassCancelled,
      this,
    );
  }
  overrideClassCancelledIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.overrideClassCancelledIsSet &&
      this.overrideClassCancelledApplyFilter(filter)
    )
      return true;

    return false;
  }
  overrideStaggeredStartApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassSignupOverridesMeta.overrideStaggeredStart,
      ClassSignupOverridesMeta,
      this.overrideStaggeredStart,
      this,
    );
  }
  overrideStaggeredStartIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.overrideStaggeredStartIsSet &&
      this.overrideStaggeredStartApplyFilter(filter)
    )
      return true;

    return false;
  }
  typeOverrideApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassSignupOverridesMeta.typeOverride,
      ClassSignupOverridesMeta,
      this.typeOverride,
      this,
    );
  }
  typeOverrideIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.typeOverrideIsSet && this.typeOverrideApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.overrideAllIsSetDeep(filter)) return true;
    if (this.overrideCanEnrollIsSetDeep(filter)) return true;
    if (this.overrideClassStartedIsSetDeep(filter)) return true;
    if (this.overrideClassCancelledIsSetDeep(filter)) return true;
    if (this.overrideStaggeredStartIsSetDeep(filter)) return true;
    if (this.typeOverrideIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
